import React, { useState } from 'react'
import style from "../SupplierManagement.module.css";
import axios from "axios";
import { Supplier_api } from "../../../Apiconfig";

const AddSupplier = () => {

  const [formData, setFormData] = useState({
    supplier_name: "",
    email: "",
    contact: "",
    shop_name: "",
    supplier_address: "",
    city: "",
    pincode: "",
  });


  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${Supplier_api}suppliers.php`,
        formData,
        {
          withCredentials: true,
        }
      );
      if (response.data.success) {
        alert(response.data.message);
        setFormData({
          supplier_name: "",
          email: "",
          contact: "",
          shop_name: "",
          supplier_address: "",
          city: "",
          pincode: "",
        });
        // fetchSuppliers();
      } else {
        alert("Error: " + response.data.message);
      }
    } catch (error) {
      console.error("Error adding supplier:", error);
      alert("An error occurred while adding the supplier.");
    }
  };
  return (
    <div>


      {/* Add Supplier Form */}
      <div className={`${style.form_container} container`}>
        <form onSubmit={handleSubmit} className={style.form}>
          <div className="row">
            <div className="col-md-6">
              <div className={style.inputGroup}>
                <input
                  type="text"
                  name="supplier_name"
                  value={formData.supplier_name}
                  onChange={handleChange}
                  placeholder="Enter supplier name"
                  required
                  className={style.input}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className={style.inputGroup}>
                <input
                  type="text"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email"
                  required
                  className={style.input}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className={style.inputGroup}>
                <input
                  type="tel"
                  name="contact"
                  value={formData.contact}
                  onChange={handleChange}
                  placeholder="Enter contact number"
                  required
                  className={style.input}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className={style.inputGroup}>
                <input
                  type="text"
                  name="shop_name"
                  value={formData.shop_name}
                  onChange={handleChange}
                  placeholder="Enter shop name"
                  required
                  className={style.input}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className={style.inputGroup}>
                <input
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  placeholder="Enter city"
                  required
                  className={style.input}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className={style.inputGroup}>
                <input
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleChange}
                  placeholder="Enter pincode"
                  required
                  className={style.input}
                />
              </div>
            </div>
          </div>
          <div className={style.inputGroup}>
            <input
              name="supplier_address"
              value={formData.supplier_address}
              onChange={handleChange}
              placeholder="Enter address"
              required
              className={style.input}
            />
          </div>
          <button type="submit" className={style.submitButton}>
            Submit
          </button>
        </form>
      </div>
    </div>



  )
}

export default AddSupplier
